<template>
  <CModal
    title="Revertir importación"
    color="dark"
    :show.sync="modalShow"
    class="basic-modal-color"
  >
    <p class="mb-2">
      Esta acción intentará deshacer los cambios de la importación seleccionada.
    </p>

    <UndoImportSummary />

    <template #footer>
      <CButton color="secondary" @click="$emit('update:show', false)">Cancelar</CButton>
      <CButton color="dark" @click="$emit('confirm')">Confirmar</CButton>
    </template>
  </CModal>
</template>

<script>
import UndoImportSummary from './UndoImportSummary.vue'

export default {
  name: 'UndoImportModal',
  components: { UndoImportSummary },
  props: {
    show: { type: Boolean, default: false }
  },
  computed: {
    modalShow: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      }
    }
  }
}
</script>
